// These are Drift orgs that specifically ask not to get tracked, such as mParticle below which is a Segment competitor
export const SEGMENT_TRACKING_BLACKLIST = [42653]



// WEBPACK FOOTER //
// ./src/constants/trackingConstants.js